import { render, staticRenderFns } from "./ModalNotice.vue?vue&type=template&id=28769a04&"
import script from "./ModalNotice.vue?vue&type=script&lang=js&"
export * from "./ModalNotice.vue?vue&type=script&lang=js&"
import style0 from "./ModalNotice.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports